/**
 * Tenta sair de um navegador interno (webview de app) e abrir a página no
 * navegador real do dispositivo. No Android usa intent:// pro Chrome; senão
 * tenta window.open e, por último, troca a location atual.
 */
export function abrirNoNavegador(): void {
  if (typeof window === 'undefined') return;

  const currentUrl = window.location.href;
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/.test(userAgent)) {
    const url = new URL(currentUrl);
    const intentUrl = `intent://${url.host}${url.pathname}${url.search}${url.hash}#Intent;scheme=https;package=com.android.chrome;end`;
    window.location.href = intentUrl;
    return;
  }

  const openedWindow = window.open(currentUrl, '_blank', 'noopener,noreferrer');
  if (!openedWindow) {
    window.location.href = currentUrl;
  }
}
